/// ESTAS CARDS SON LAS QUE SE RENDERIZAN ///

import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { BsCalendarCheck } from "react-icons/bs";

import Translate from "../../i18n/Translate";
import { LocationDetailIcon } from "../icons";

import imgPlaceholder from "../../assets/images/static/sport__hero_desktop.jpg";

const Cards = ({ card, index }) => {
  const { t } = useTranslation();

  return (
    <>
      <Link
        className="sport__cards"
        style={{ animationDelay: `0.${index}s` }}
        to={`${t("routes.psportsdetails")}/${card.title
          .replace(/ /g, "-")
          .toLowerCase()}/${card.id}`}
      >
        <div className="sport__cards__image">
          <img
            src={card.image ? card.image : imgPlaceholder}
            alt={card.title}
            title={card.title.toUpperCase()}
          />
        </div>

        <div className="sport__cards__content">
          <div className="sport__cards__date">
            <p>
              <BsCalendarCheck /> {card.date.join(" - ")}
            </p>
          </div>

          <div className="sport__cards__text">
            <h4>{card.title}</h4>

            <hr />

            <p>{card.description}</p>
          </div>

          <div className="sport__cards__info">
            <span>
                <LocationDetailIcon /> {card.location.replace("-", " ")}
            </span>

            <div className="sport__cards__buttons">  
              <button>
                <Translate langkey="globals.more-info" />
              </button>
              
              <h4>USD {card?.details?.price?.toLocaleString()}</h4>
            </div>
          </div>

        </div>
      </Link>
    </>
  );
};

export default Cards;
